const GET_UPFIT_OPTION = 'GET_UPFIT_OPTION';
const SET_UPFIT_OPTION = 'SET_UPFIT_OPTION';

export {
    GET_UPFIT_OPTION,
    SET_UPFIT_OPTION
};
